// Book-a-Call insertion token. The compose surfaces insert THIS TOKEN only —
// the backend substitutes the real booking URL at send time (branded CTA button
// in branded emails, labeled text link in plain personal letters), so the URL
// never ships in the bundle.
export const BOOKING_TOKEN = '[BOOK-A-CALL LINK]';

// Insert the token at the caret of a textarea (falling back to append) and
// return the new string for setState.
//
// The token ALWAYS lands on its own line, never mid-sentence. Both render paths
// depend on it: extract_token() (branded) drops a token-only line cleanly, so the
// sentence above it must already be complete — a token dropped after "Here is one
// that works:" leaves a dangling colon in the branded email. substitute_inline_link()
// (personal) reads fine either way, so own-line is correct for both.
export function insertBookingToken(textareaEl, value) {
  const token = BOOKING_TOKEN;
  if (!textareaEl) {
    return `${value.trimEnd()}\n\n${token}\n`;
  }
  const start = textareaEl.selectionStart ?? value.length;
  const end = textareaEl.selectionEnd ?? value.length;
  const before = value.slice(0, start).replace(/[ \t]+$/, '');
  const after = value.slice(end).replace(/^[ \t]+/, '');
  // pad out to a blank line on each side so the token owns its line
  const lead = before === '' ? '' : before.endsWith('\n\n') ? '' : before.endsWith('\n') ? '\n' : '\n\n';
  const trail = after === '' ? '\n' : after.startsWith('\n\n') ? '' : after.startsWith('\n') ? '\n' : '\n\n';
  const next = `${before}${lead}${token}${trail}${after}`;
  // restore focus + caret just after the token on the next tick
  const caret = (before + lead + token).length;
  setTimeout(() => {
    textareaEl.focus();
    textareaEl.setSelectionRange(caret, caret);
  }, 0);
  return next;
}
